import { Container } from "../components/common-components";
import { FormHeader } from "../components/FormHeader";
import { FormFooter } from "../components/FormFooter";
import { useContext } from "react";
import { FormContextAMR } from "../form-context";
import NotesList from "../components/NotesList";
import { useParams } from "react-router-dom";
import { MedicationReviewDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";

export const NotepadFormAMR = ({}) => {
  const { serviceId, summaryId } = useParams();
  const {
    patient,
    formType,
    clinicalServiceName,
    notepad,
    startDateTime,
    endDateTime,
  } = useContext(FormContextAMR);

  return (
    <div className="space-y-20">
      {/* Page 1: Pharmacist Comments */}
      <Container>
        <>
          <FormHeader cover={false} formType={MedicationReviewDocTypes.NotepadPharmacist} />
          <NotesList 
            notepad={notepad}
            clinicalServiceName={clinicalServiceName}
            patient={patient}
            startDateTime={startDateTime}
            serviceId={null}
            summaryId={summaryId}
            commentType="pharmacist"
            showOnlyPatientChart={false}
          />
          <FormFooter />
        </>
      </Container>

      {/* Page 2: Patient Comments */}
      <Container>
        <>
          <FormHeader cover={false} formType={MedicationReviewDocTypes.NotepadPatient} />
          <NotesList 
            notepad={notepad}
            clinicalServiceName={clinicalServiceName}
            patient={patient}
            startDateTime={startDateTime}
            serviceId={null}
            summaryId={summaryId}
            commentType="patient"
            showOnlyPatientChart={false}
          />
          <FormFooter />
        </>
      </Container>
    </div>
  );
};

export default NotepadFormAMR;
